/* ================================
   CLUB REELS — MICRO INTERACTIONS
   ================================ */

document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.club-reel-card');
  if (!cards.length) return;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  cards.forEach(card => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(20px)';
    observer.observe(card);
  });
});
/* =========================================================
   CLUB REELS — FIX SWIPE MOBILE (IFRAME SAFE)
========================================================= */

document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('.club-reels__grid');
  if (!grid) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  grid.addEventListener('touchstart', (e) => {
    isDown = true;
    startX = e.touches[0].pageX;
    scrollLeft = grid.scrollLeft;
  }, { passive: true });

  grid.addEventListener('touchmove', (e) => {
    if (!isDown) return;

    const x = e.touches[0].pageX;
    const walk = startX - x;

    // Si el movimiento es claramente horizontal
    if (Math.abs(walk) > 10) {
      grid.scrollLeft = scrollLeft + walk;
    }
  }, { passive: true });

  grid.addEventListener('touchend', () => {
    isDown = false;
  });
});

